
<div>
  <poppins-card ref="targetElement" class="py-32">
    <div class="flex gap-16">
      <poppins-avatar :imageUrl="profileAccountData.photoUrl" size="mega" :name="profileAccountData.displayName" />
      <div>
        <h2 class="text-h3 break-all">{{ displayName }}</h2>
        <star-rating
          v-if="profileAccountData.reviews"
          :count="profileAccountData.reviews.totalReviewCount"
          :average="profileAccountData.reviews.starAggregate"
          class="cursor-pointer"
          @click="handleClick('star-rating-click')"
        />
      </div>
    </div>
    <icon-list :items="iconListItems" class="mt-8" :customMargin="16" @item-click="handleItemClick" />
    <poppins-button :value="buttonValue" class="w-full mt-16" size="large" />
  </poppins-card>
  <div
    v-if="scrolledPast"
    class="fixed left-0 bg-white w-full z-[60] p-16 border-t-1 border-b-1 border-solid border-grey-divider-subdued"
    :class="accountTypeInfo.isParent ? 'bottom-80' : 'bottom-0'"
  >
    <div class="flex gap-16">
      <poppins-avatar :imageUrl="profileAccountData.photoUrl" size="large" :name="profileAccountData.displayName" />
      <div>
        <p v-html="stickyRate" />
        <star-rating
          v-if="profileAccountData.reviews"
          :count="profileAccountData.reviews.totalReviewCount"
          :average="profileAccountData.reviews.starAggregate"
        />
      </div>
      <div v-if="accountTypeInfo.isParent" class="w-full text-right self-center mr-16">
        <provider-profile-favorite-sitter-button
          :favoritedSitter="favoritedSitter"
          :sitterAccountId="sitterAccountId"
          @favoritedSitterChange="favoritedSitterChange"
        />
      </div>
    </div>
    <poppins-button :value="buttonValue" class="w-full mt-16" size="medium" />
  </div>
</div>
